module.exports = __webpack_public_path__ + "static/media/Services-04.2287536b.jpg";